import Button from "@/components/Button"
import Field from "@/components/Field"
import TextInput from "@/components/TextInput"
import { useToasts } from "@/hooks/Toasts/useToasts"
import { isRequired } from "@/util/formValidators"
import clsx from "clsx"
import copy from "copy-to-clipboard"
import { Form } from "informed"
import classes from "./influencerForm.module.css"

const InfluencerForm = (props) => {
  const { influencerData, onPaypalAccountSubmit } = props

  const [, { addToast }] = useToasts()

  const onCopy = () => {
    copy(influencerData.reference_link)
    addToast({
      type: "info",
      message: "Reference link has coppied to the clipboard",
      timeout: 3000,
    })
  }

  return (
    <div className={classes.root}>
      <Form
        onSubmit={onPaypalAccountSubmit}
        initialValues={influencerData}
        className={classes.form}
      >
        <Field
          id='paypal_account'
          label='Paypal Account'
          classes={{
            root: classes.formField,
          }}
        >
          <TextInput
            autoComplete='paypal_account'
            field='paypal_account'
            id='paypal_account'
            validate={isRequired}
            classes={{
              input: classes.fieldInput,
            }}
          />
        </Field>
        <Field
          classes={{
            root: classes.buttonField,
          }}
        >
          <Button
            type='submit'
            classes={{
              root: classes.submitButton,
            }}
          >
            save
          </Button>
        </Field>
      </Form>

      <Form
        initialValues={influencerData}
        className={clsx(classes.form, "mt-3")}
      >
        <Field
          id='reference_link'
          label='Reference Link'
          classes={{
            root: classes.formField,
          }}
        >
          <TextInput
            autoComplete='reference_link'
            field='reference_link'
            id='reference_link'
            disabled={true}
            classes={{
              input: classes.fieldInput,
            }}
          />
        </Field>
        <Field
          classes={{
            root: classes.buttonField,
          }}
        >
          <Button
            classes={{
              root: classes.submitButton,
            }}
            onClick={onCopy}
          >
            COPY
          </Button>
        </Field>
      </Form>
    </div>
  )
}

export default InfluencerForm
